import { createRequest } from '../helpers/api_utils';
import { apiUrl } from './api_url';

const apiEndpoint = apiUrl + '/credits';

/** Every metered feature for the caller's organization, this month. */
export function getCredits() {
  return fetch(createRequest(apiEndpoint, 'GET', 'application/json', true));
}

export function getFeatureCredits(feature: string) {
  return fetch(createRequest(`${apiEndpoint}/${feature}`, 'GET', 'application/json', true));
}
